import { Card, CardContent } from '@/components/ui/card'
import config from '../../../../../config'
import { useTranslation } from '@/hooks/useTranslation'

export const ShopifySection = () => {
	const { t } = useTranslation()
	
	return (
		<section id="shopify" className="mb-16">
			<h2 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-6">
				{t('docs.shopify.title')}
			</h2>
			<Card className="shadow-sm dark:bg-gray-800/50">
				<CardContent className="pt-6">
					<ol className="list-decimal pl-5 space-y-3 text-gray-700 dark:text-gray-300">
						<li>{t('docs.shopify.step1')}</li>
						<li>
							{t('docs.shopify.step2.prefix')}{' '}
							<strong>{t('docs.shopify.step2.menuPath')}</strong>
						</li>
						<li>
							{t('docs.shopify.step3.prefix')}{' '}
							<strong>{t('docs.shopify.step3.menuPath')}</strong>{' '}
							{t('docs.shopify.step3.suffix')}
						</li>
						<li>
							{t('docs.shopify.step4.prefix')}{' '}
							<strong>{t('docs.shopify.step4.fileName')}</strong>{' '}
							{t('docs.shopify.step4.suffix')}
						</li>
						<li>
							{t('docs.shopify.step5.prefix')}{' '}
							<code className="bg-gray-200 dark:bg-gray-700 px-1 py-0.5 rounded text-xs">
								&lt;/body&gt;
							</code>{' '}
							{t('docs.shopify.step5.suffix')}
						</li>
						<li>
							{t('docs.shopify.step6.prefix')}{' '}
							{config.appName}{' '}
							{t('docs.shopify.step6.suffix')}
						</li>
						<li>
							{t('docs.shopify.step7.prefix')}{' '}
							<strong>{t('docs.shopify.step7.button')}</strong>
						</li>
					</ol>
					<div className="mt-6 p-4 bg-yellow-50 dark:bg-yellow-900/20 rounded-md">
						<p className="text-sm text-yellow-800 dark:text-yellow-200">
							<strong>{t('docs.shopify.warning.label')}</strong>{' '}
							{t('docs.shopify.warning.text')}
						</p>
					</div>
				</CardContent>
			</Card>
		</section>
	)
}